import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Position.css';
import Card from '../Card/Card';
import { Copy } from 'lucide-react';

const PositionSnippet = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <>
      <pre>
        <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={snippetContainerRef}>
            <code>
              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-spot-relative</span><span class="cln">"</span><span class="cn">&gt;</span>position relative element<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-spot-absolute</span><span class="cln">"</span><span class="cn">&gt;</span>position absolute element<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-spot-freeze</span><span class="cln">"</span><span class="cn">&gt;</span>position fixed element<span class="cn">&lt;/div&gt;</span><br />

              <span class="cn">&lt;div</span><span class="cln"> class="</span><span class="cn">carve-spot-hange</span><span class="cln">"</span><span class="cn">&gt;</span>position hang element<span class="cn">&lt;/div&gt;</span>

            </code>
          </div>
          <button aria-label="Copy Button" onClick={copySnippet}>
            <Copy />
          </button>
        </div>
      </pre>
    </>
  );
}
const Position = () => {

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Card
        CardTitle='Positions'
        CardBody={<PositionSnippet />}
      />
    </motion.div>
  );
}

Position.propTypes = {};

export default Position;
